import {Box, IconButton, Stack, Typography} from "@mui/material"
import {FC} from "react"
import {CloseIcon} from "../../../assets"
import Search from "../../molecules/search/search"
import useExpertBioStore from "../../../stores/expertBioStore"
import {useQueryClient} from "@tanstack/react-query"
import {expertListStore} from "../../../stores"

type Props = {
  setShowFindExpert: (showAccountPanel: boolean) => void
  filters: any
  onSearchTextChange: (text: string) => void
}

const SearchExpert: FC<Props> = (props) => {
  const {setShowFindExpert} = useExpertBioStore()
  const {regions, searchTerm, clearSearchTerm, clearRegion} = expertListStore()
  const queryClient = useQueryClient()
  const handleTextChange = (text: string) => {
    props.onSearchTextChange(text)
  }
  const handleCloseClick = () => {
    queryClient.cancelQueries({queryKey: ["getExperts", "searchExperts"]})
    setShowFindExpert(false)

    if (regions !== "" || searchTerm !== "") {
      setTimeout(() => {
        clearRegion()
        clearSearchTerm()
      }, 1000)
    }
  }

  return (
    <Stack spacing={2} p={2} padding={"16px 24px 0px 24px"}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box>
          <Typography
            fontSize={20}
            fontWeight={600}
            color={"#242d35"}
            lineHeight={"24px"}
          >
            Find an expert
          </Typography>
        </Box>
        <IconButton onClick={() => handleCloseClick()}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Search
        placeholder="Search name, location or speciality"
        onTextChange={handleTextChange}
        style={{
          paddingTop: "5px",
        }}
        paperStyle={{
          height: "40px",
          border: "solid 1px #cdcdcd",
          borderRadius: "4px",
        }}
        inputStyle={{fontSize: "16px", color: "#7a7a79"}}
        filterState={{setFilters: () => {}}}
      ></Search>
    </Stack>
  )
}

export default SearchExpert
